import React, { useEffect, useRef } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { projectName } from "../util/Config";
import useTranslation from "../hooks/useTranslation";
import { T, pageBgStyle, bgImage } from "../util/theme";

import "../assets/css/custom.css";

import homeIcon from "../assets/images/bottombar/home.svg";
import darkHomeIcon from "../assets/images/bottombar/dark-home.svg";
import hostIcon from "../assets/images/bottombar/host.svg";
import darkHostIcon from "../assets/images/bottombar/dark-host.svg";
import applicationIcon from "../assets/images/bottombar/application.svg";
import darkApplicationIcon from "../assets/images/bottombar/dark-application.svg";
import userIcon from "../assets/images/bottombar/user.svg";
import darkUserIcon from "../assets/images/bottombar/dark-user.svg";

const ACTIVE_GRAD = "linear-gradient(84.57deg, #FD297E 0%, #6B01FF 100%)";

export default function AgencyLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const contentRef = useRef(null);

  // Reset scroll when navigating to another page
  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const navItems = [
    {
      // label: t("dashboard"),
      path: "/agencypanel/homePage",
      icon: homeIcon,
      activeIcon: darkHomeIcon,
    },
    {
      // label: t("hosts"),
      path: "/agencypanel/creators",
      icon: hostIcon,
      activeIcon: darkHostIcon,
    },
    {
      // label: t("applications"),
      path: "/agencypanel/creatorRequest",
      icon: applicationIcon,
      activeIcon: darkApplicationIcon,
    },
    {
      // label: t("payouts"),
      path: "/agencypanel/agencyredeem",
      icon: userIcon,
      activeIcon: darkUserIcon,
    },
  ];

  const item = ({ label, path, icon, activeIcon }, isSidebar = false) => {
    const isActive = location.pathname === path;
    const iconSrc = isActive ? activeIcon : icon;

    return (
      <button
        key={path}
        onClick={() => navigate(path)}
        style={{
          border: "none",
          background: isSidebar
            ? isActive
              ? "rgba(255,255,255,0.1)"
              : "transparent"
            : "transparent",
          display: "flex",
          flexDirection: isSidebar ? "row" : "column",
          alignItems: "center",
          justifyContent: "center",
          gap: isSidebar ? 12 : 6,
          padding: isSidebar ? "10px 16px" : "10px 4px 8px",
          cursor: "pointer",
          width: isSidebar ? "90%" : "100%",
          margin: isSidebar ? "5px auto" : 0,
          borderRadius: isSidebar ? "8px" : 0,
          position: "relative",
          height: isSidebar ? "auto" : "100%",
        }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 0,
            opacity: isActive ? 1 : 0.5,
          }}
        >
          <img
            src={iconSrc}
            alt=""
            width={20}
            height={20}
            style={{ objectFit: "contain", display: "block" }}
          />
        </span>

        {!isSidebar && isActive && (
          <span
            style={{
              position: "absolute",
              bottom: 8,
              left: "50%",
              transform: "translateX(-50%)",
              width: 50,
              height: 3.5,
              borderRadius: 999,
              background: ACTIVE_GRAD,
            }}
          />
        )}
      </button>
    );
  };

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        ...pageBgStyle,
      }}
    >
      {/* Sidebar (desktop) */}
      <div
        className="sidebar-nav"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h2
          style={{
            color: "#E8538F",
            fontSize: 20,
            fontWeight: 700,
            marginBottom: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "8px 0",
          }}
        >
          {projectName}
        </h2>
        {navItems.map((nav) => item(nav, true))}
      </div>

      {/* Page content */}
      <div
        ref={contentRef}
        style={{
          flex: 1,
          paddingBottom: 70,
          color: T.text,
          overflowX: "hidden",
          overflowY: "auto",
          height: "100vh",
          background: "transparent",
        }}
      >
        <Outlet />
      </div>

      {/* Bottom Tabs (mobile) */}
      <div className="bottom-nav">{navItems.map((nav) => item(nav, false))}</div>
    </div>
  );
}
